import utils from '@/utils';
export default {
  methods: {
    /**
     * set open edit item state
     * @param {Object} item
     * @param {String} itemName
     * @param {String} dataSourceName
     */
    openEditItem(item, itemName, dataSourceName) {
      item[itemName + 'Edit'] = true
      item.editData = true
      this.showEditActions = true
      this[dataSourceName] = utils.func.refreshJSON(this[dataSourceName])
    },
    /**
     * this will reset edit fields to default state
     * @param {Array} records
     * @param {Array} fields
     * @returns
     */
    resetEditFields(records, fields) {
      this.showEditActions = false
      records = records.map(record => {
        fields.map(fieldName => {
          record[fieldName + 'Edit'] = false
        })
        record.editData = false
        return record
      })
      return records
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DataTableMixin.js